import React from 'react';
import PropTypes from 'prop-types';
import styles from './ArticleList.module.scss';

const ArticleListItem = ({
  imgSrc,
  articleTitle,
  articleUrl,
}) => {
  return (
    <>
      <div className={styles['content-item']} data-testid="content-item">
        <a href={articleUrl}>
          {/* Linked StudioID articles use title as alt text */}
          <img className={styles['content-item__image']} src={imgSrc} alt={articleTitle} />
        </a>
        <a className={styles['content-item__title']} href={articleUrl} data-testid="content-item__title">{articleTitle}</a>
        <p className={styles['content-item__cta']}>
          <a className="call-out-link call-out-link--primary" href={articleUrl}>
            Read now <span className="call-out-link__arrow">➔</span>
          </a>
        </p>
      </div>
    </>
  );
};

ArticleListItem.propTypes = {
  imgSrc: PropTypes.string.isRequired,
  articleTitle: PropTypes.string.isRequired,
  articleUrl: PropTypes.string.isRequired,
};

export default ArticleListItem;
